import contract from '@mailobj-browser/front/js/contracts/contract.js'
import mains from './mains/mains.js'
import subparts from './subparts/subparts.js'

export default contract({
  mains,
  subparts
})
